import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
  questionColumn,
  codeColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA } from "../../../../../utils/commonFunctions";

const orderColumn: ColDef = {
  field: "order",
  headerName: "Order",
  filter: "agNumberColumnFilter",
};

const typeColumn: ColDef = {
  field: "type",
  headerName: "Type",
};

const columnDefs: ColDef[] = [
  idColumn,
  typeColumn,
  codeColumn,
  {
    ...generateColumn("Industry Name", "industry_name"),
    cellRenderer: (props: any) => {
      return renderNA(props?.data?.industry_name);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.industry_name);
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(props?.data?.industry_name);
    },
    valueGetter: (props: any) => {
      return props?.data?.industry_name;
    },
  },
  questionColumn,
  orderColumn,
  statusColumn,
  actionColumn,
];

export default columnDefs;
